'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PermissionProvider = function (_Component) {
  _inherits(PermissionProvider, _Component);

  _createClass(PermissionProvider, null, [{
    key: 'propTypes',
    get: function get() {
      return {
        permissions: _propTypes2.default.arrayOf(_propTypes2.default.shape({
          moduleCode: _propTypes2.default.string,
          functionCode: _propTypes2.default.string,
          actionCode: _propTypes2.default.string
        })).isRequired,
        children: _propTypes2.default.node
      };
    }
  }, {
    key: 'childContextTypes',
    get: function get() {
      return {
        isActionAllowed: _propTypes2.default.func,
        isActionDenied: _propTypes2.default.func
      };
    }
  }]);

  function PermissionProvider() {
    _classCallCheck(this, PermissionProvider);

    var _this = _possibleConstructorReturn(this, (PermissionProvider.__proto__ || Object.getPrototypeOf(PermissionProvider)).call(this));

    ['getPermissions', 'getPassedPermissions', 'isActionAllowed', 'isActionDenied'].forEach(function (fn) {
      _this[fn] = _this[fn].bind(_this);
    });
    return _this;
  }

  _createClass(PermissionProvider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        isActionAllowed: this.isActionAllowed,
        isActionDenied: this.isActionDenied
      };
    }
  }, {
    key: 'getPermissions',
    value: function getPermissions() {
      return this.props.permissions || [];
    }
  }, {
    key: 'getPassedPermissions',
    value: function getPassedPermissions(functionCode, actionCode) {
      var permissions = this.getPermissions();
      var functionCodes = (0, _utils.toArray)(functionCode);
      var passedPermissions = permissions.filter(function (item) {
        return (0, _utils.getFnCode)(item, functionCodes);
      });
      if (actionCode) {
        var actionCodes = (0, _utils.toArray)(actionCode);
        passedPermissions = passedPermissions.filter(function (item) {
          return (0, _utils.getActionCode)(item, actionCodes);
        });
      }
      return (0, _utils.isContainArray)(permissions) && passedPermissions;
    }
  }, {
    key: 'isActionAllowed',
    value: function isActionAllowed(functionCode, actionCode) {
      (0, _utils.validateFunctionCode)(functionCode);
      var passedPermissions = this.getPassedPermissions(functionCode, actionCode);
      return passedPermissions.length > 0;
    }
  }, {
    key: 'isActionDenied',
    value: function isActionDenied(functionCode, actionCode) {
      return !this.isActionAllowed(functionCode, actionCode);
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;

      return children ? _react.Children.only(children) : null;
    }
  }]);

  return PermissionProvider;
}(_react.Component);

exports.default = PermissionProvider;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@mayo/user-permissions/lib/components/PermissionProvider.js
 ** module id = 248
 ** module chunks = 0
 **/